import { Box, CircularProgress, alpha } from '@mui/material'
const Loader: React.FC<{ size?: number; sx?: any }> = ({ size = 20, sx = {} }) => {
  return (
    <Box position="relative" width={`${size}px`} height={`${size}px`} sx={sx}>
      <CircularProgress
        variant="determinate"
        sx={{
          color: (theme) =>
            alpha(theme.palette.grey[theme.palette.mode === 'light' ? 400 : 800], 0.5),
        }}
        size={size}
        thickness={4}
        value={100}
      />
      <CircularProgress
        variant="indeterminate"
        size={size}
        sx={{ position: 'absolute', left: 0, top: 0 }}
      />
    </Box>
  )
}

export default Loader
